import type { FC } from "react";
import React from "react";
import { useBrand } from "@edreamsodigeo/frontend-core";
import { Pill } from "@edreamsodigeo/prisma-design-system";

import type { LightboxPinProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxPill/types";

const LightboxPill: FC<LightboxPinProps> = ({ type, rounded, children }) => {
  const isEdreams = useBrand() === "ED";
  return (
    <Pill
      type={type}
      rounded={rounded}
      style={{ color: isEdreams && type === "promotional" ? "unset" : "white" }}
    >
      {children}
    </Pill>
  );
};

export default LightboxPill;
